<template>
  <div style="overflow-x: hidden;">
    <b-card>
      <el-row :gutter="10">
        <div class="d-flex ">
          <div class="side-frame"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              面料信息
            </span>
          </div>
        </div>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>物料编码：</span>
            </div>
            <div class="showText">
              <span>{{ formData.fabricNo }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>物料名称：</span>
            </div>
            <div class="showText">
              <span>{{ formData.fabricName }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>门幅：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_fabricWidth }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>克重：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_fabricWeight }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>颜色：</span>
            </div>
            <div class="showText">
              <span>{{ formData.fabricColor }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>采购单号：</span>
            </div>
            <div class="showText">
              <span>{{ formData.purchaseFabricNo }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>源头订单号：</span>
            </div>
            <div class="showText">
              <span>{{ formData.originOrderNo }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>采购人员：</span>
            </div>
            <div class="showText">
              <span>{{ formData.buyerName }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>供方：</span>
            </div>
            <div class="showText">
              <span>{{ formData.scmName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>需方：</span>
            </div>
            <div class="showText">
              <span>{{ formData.purchaserEntityName }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>系列：</span>
            </div>
            <div class="showText">
              <span>{{ formData.series }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <div class="d-flex">
            <div class="show_fabric_title">
              <span>规格型号：</span>
            </div>
            <div class="showText">
              <span>{{ formData.fabricContent }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </b-card>

    <!-- 入库登记 -->
    <b-card>
      <el-row :gutter="10">
        <div class="d-flex">
          <div class="side-frame-success"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              入库登记
            </span>
          </div>
        </div>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_register_title">
              <span>实际到料日期：</span>
            </div>
            <div class="showText">
              <span>{{ formData.arrivalDate }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_register_title">
              <span>来料总数量(米)：</span>
            </div>
            <div class="showText">
              <span>{{ formData.totalArrivalQuantity }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_register_title">
              <span>来料总匹数：</span>
            </div>
            <div class="showText">
              <span>{{ formData.totalArrivalRolls }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="show_register_title">
              <span>仓库收货人员：</span>
            </div>
            <div class="showText">
              <span>{{ formData.whReceiverNames }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </b-card>

    <!-- 入库检验 -->
    <b-card>
      <el-row :gutter="10">
        <div class="d-flex ">
          <div class="side-frame-warning"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              入库检验
            </span>
          </div>
        </div>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>检验日期：</span>
            </div>
            <div class="showText">
              <span>{{ formData.inspectionDate }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>检验人员：</span>
            </div>
            <div class="showText">
              <span>{{ formData.reporterNames }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>检验总匹数：</span>
            </div>
            <div class="showText">
              <span>{{ formData.totalInspectionRolls }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>合格匹数：</span>
            </div>
            <div class="showText">
              <span>{{ formData.totalQualifiedRolls }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>不良匹数：</span>
            </div>
            <div class="showText">
              <span>{{ formData.totalDefectiveRolls }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>疵点总数：</span>
            </div>
            <div class="showText">
              <span>{{ formData.totalDefectCount }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>利用率：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_totalUtilizationRate }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>质量成本系数：</span>
            </div>
            <div class="showText">
              <span>{{ formData.qualityCostIndex }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>短码数量(米)：</span>
            </div>
            <div class="showText">
              <span>{{ formData.totalShortQuantity }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>短码率：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_totalShortRate }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>让步接收数量(米)：</span>
            </div>
            <div class="showText">
              <span>{{ formData.totalLetGoQuantity }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>退货数量(米)：</span>
            </div>
            <div class="showText">
              <span>{{ formData.totalReturnQuantity }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>入库数量(米)：</span>
            </div>
            <div class="showText">
              <span>{{ formData.inStockQuantity }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>判定结果：</span>
            </div>
            <div class="showText">
              <span
                :style="{
                  color:
                    formData.inspectionResult === 'Y' ? ' #28A745' : ' #DC3545',
                }"
                >{{ formData.v_inspectionResult }}</span
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </b-card>
    <b-card>
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <div>
            <div class="d-flex ">
              <div class="side-frame-warning"></div>
              <div>
                <span style="font-size: 14px; color: #606266">
                  码单图片
                </span>
              </div>
            </div>
            <div class="mt-2" v-if="imageList">
              <swiper :options="swiperOption">
                <swiper-slide v-for="(item, index) in imageList" :key="index">
                  <div class="swiper-zoom-container">
                    <el-image
                      style="width: 150px; height:200px"
                      fit="cover"
                      :src="item.fileUrl"
                      @click="imageView(index, imageList)"
                    ></el-image>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </el-col>
      </el-row>
    </b-card>
    <b-card>
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <div>
            <div class="d-flex ">
              <div class="side-frame-warning"></div>
              <div>
                <span style="font-size: 14px; color: #606266">
                  检验明细
                </span>
              </div>
            </div>
            <ItemTable
              ref="itemTable"
              class="mb-2"
              :tableData="formData.inspectionDetailList"
            />
          </div>
        </el-col>
      </el-row>
    </b-card>
    <div v-show="false" ref="viewBigVisitImage" v-viewer="{ movable: true }">
      <img
        v-for="src in imageList"
        :src="src.fileUrl"
        :key="src.inspectionImageCode"
      />
    </div>
  </div>
</template>

<script>
import ItemTable from '../item-table'
import { groupBy, map } from 'lodash'
export default {
  components: { ItemTable },
  props: {
    inspectionCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      imageList: [],
      swiperOption: {
        breakpoints: {
          // 当屏幕宽度 >= 768px 时
          350: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          // 当屏幕宽度 >= 768px 时
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          // 当屏幕宽度 >= 1024px 时
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 5,
          },
          // 当屏幕宽度 >= 1200px 时
          1200: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
          // 当屏幕宽度 >= 1400px 时
          1400: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
          // 当屏幕宽度 >= 1600px 时
          1600: {
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        },
        spaceBetween: 10,
        loop: false,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f1f1f1;')
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.inspectionCode) return
      this.$api.opaGetFabricInspectionApi(this.inspectionCode).then((res) => {
        this.formData = res.body || {}
        const { fabricWidth, fabricWidthUnit } = this.formData || {}
        this.formData.v_fabricWidth = [fabricWidth, fabricWidthUnit]
          .filter(Boolean)
          .join(' ')
        const {
          fabricWeight,
          fabricWeightUnit,
          totalUtilizationRate = 0,
          totalShortRate = 0,
          inspectionDetailList = [],
          imageList = [],
        } = this.formData
        this.formData.v_fabricWeight = [fabricWeight, fabricWeightUnit]
          .filter(Boolean)
          .join(' ')
        this.formData.v_totalUtilizationRate = (totalUtilizationRate || 0) + '%'
        this.formData.v_totalShortRate = (totalShortRate || 0) + '%'
        this.imageList = imageList || []
        inspectionDetailList.forEach((item) => {
          item.inspectionDefectList = this.getInspectionDefectList(
            item.inspectionDefectList
          )
          item.requestList = this.getInspectionDefectList(item.requestList)
        })
      })
    },
    getInspectionDefectList(data) {
      const groupedData = groupBy(data, 'defectIssuesGroup')
      return map(groupedData, (group, groupName) => {
        const defects = group
          .map((item) => {
            const defectIssuesTitle = this.formatDefectIssuesTitle(item)
            return item.quantity
              ? `${defectIssuesTitle}*${item.quantity}`
              : defectIssuesTitle
          })
          .join(',')
        return `${groupName}：${defects}`
      })
    },
    formatDefectIssuesTitle(item = {}) {
      const defectIssuesTitle = (item.defectIssuesTitle || '').trim()
      const otherProblemDesc = `${item.otherProblemDesc || ''}`.trim()
      if (defectIssuesTitle === '其他' && otherProblemDesc) {
        return `${defectIssuesTitle}：${otherProblemDesc}`
      }
      return defectIssuesTitle
    },
    imageView(index, imageList) {
      if (imageList.length > 0) {
        const viewer = this.$refs.viewBigVisitImage.$viewer
        this.viewerImageList = imageList
        viewer.view(index)
        viewer.show()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  margin: 10px 10px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin: 3px 0 10px 0;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin: 3px 0 10px 0;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin: 3px 0 10px 0;
}
.showTitle {
  font-size: 14px;
  color: $color-text-sub;
  width: 130px;
  min-width: 130px;
}
.show_fabric_title {
  font-size: 14px;
  color: $color-text-sub;
  width: 90px;
  min-width: 90px;
}
.show_register_title {
  font-size: 14px;
  color: $color-text-sub;
  width: 110px;
  min-width: 110px;
}
.showText {
  font-size: 14px;
  color: $color-text-normal;
  width: 100%;
}
</style>
